import { listboxStyles as fastListboxStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationListboxStyles = (context, definition) => css `
  ${fastListboxStyles(context, definition)}

  :host {
    display: flex;
    flex-direction: column;
    max-width: fit-content;
    padding: calc(var(--design-unit) * 1px) 0;
    border: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-rest);
    border-radius: calc(var(--control-corner-radius) * 1px);
  }
`;
